import React, { useCallback } from "react";
import t from "common/i18n";
import { Combobox } from "@cld/combobox";
import { EDITORIAL_SLUG, ORIENTATION_OPTIONS } from "../../data/consts";
import { useFilterParams, useSearchParams } from "../../selectors";
import { getSelectedItemByValue } from "../../utils";
import { SectionBox } from "./Filters.styles";

export default ({ handleSearch }) => {
	const { orientation } = useFilterParams();
	const { slug, searchPhrase } = useSearchParams();

	const disabled = (!slug || slug === EDITORIAL_SLUG) && !searchPhrase;
	const options = !disabled ? ORIENTATION_OPTIONS.map((value: string) => ({ label: t(`unsplash.filters.orientation.${value}`), value })) : [];
	const selectedItem = getSelectedItemByValue(orientation, options) ?? null;

	const filterChange = useCallback((item) => {
		handleSearch({
			filters: {
				orientation: item?.value
			}
		});
	}, [handleSearch]);
	
	return (<SectionBox data-test="orientation-section" disabled={disabled}>
		<label>{t("unsplash.filters.orientation.label")}</label>
		<Combobox
			size="md"
			isDisabled={disabled}
			isSearchable={false}
			placeholder={t("unsplash.select")}
			options={options}
			value={selectedItem}
			onChange={filterChange} />
	</SectionBox>);
};
